import RegistrationPage from './registration-page';

Vue.component(RegistrationPage.name, RegistrationPage);
